import React from 'react';
import { Modal, Typography, Space, Button, Result } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { statusTokens } from '../../../theme/theme';

// Color constants from theme
const COLORS = {
    SUCCESS: statusTokens.success,
};

const { Text, Paragraph } = Typography;

/**
 * Modal component for showing successful asset order quote request
 * 
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onClose - Function called when closing the modal
 * @param {number} props.productsCount - Number of products in the quote request
 */
const SuccessOrderModal = ({
    visible,
    onClose,
    productsCount = 0
}) => {
    return (
        <Modal
            title={null}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
            centered
            closable={false}
        >
            <Result
                icon={<CheckCircleOutlined style={{ color: COLORS.SUCCESS }} />}
                title="Quote Request Submitted Successfully!"
                subTitle={
                    <Space direction="vertical" size="medium" style={{ width: '100%' }}>
                        <div>
                            <Text>
                                Your quote request for <strong>{productsCount}</strong> {productsCount === 1 ? 'item' : 'items'} has been submitted successfully.
                            </Text>
                        </div>

                        <div style={{ textAlign: 'left', marginTop: '1rem' }}>
                            <Paragraph>
                                <strong>What happens next:</strong>
                            </Paragraph>
                            <ul style={{ paddingLeft: '1.5rem', margin: 0, textAlign: 'left' }}>
                                <li>Our team will review your selected items</li>
                                <li>You'll receive a detailed quote within 24-48 hours</li>
                                <li>The quote will include pricing, availability, and delivery times</li>
                                <li>You can track the status in your orders list</li>
                            </ul>
                        </div>

                        <div style={{ marginTop: '1rem' }}>
                            <Text type="secondary">
                                You'll receive an email notification when your quote is ready.
                            </Text>
                        </div>
                    </Space>
                }
                extra={
                    <Button
                        type="primary"
                        size="large"
                        icon={<CheckCircleOutlined />}
                        onClick={onClose}
                    >
                        Continue
                    </Button>
                }
            />
        </Modal>
    );
};

export default SuccessOrderModal; 